window.toggleMarketplaceBlockItem = function (categoryId) {
    $('#mat-expansion-indicator-' + categoryId).toggleClass('flip');
}